export const GRAPHQL_URL = `${window.ENV.HTTP_URL}/pinger/graphql`
// export const GRAPHQL_URL = 'http://localhost:4001/graphql'
